import { defaultStatus } from '../defaultState/defaultState';
import {
  ADD_STAFF_FAILURE,
  ADD_STAFF_REQUEST,
  ADD_STAFF_SUCCESS,
  DELETE_STAFF_FAILURE,
  DELETE_STAFF_REQUEST,
  DELETE_STAFF_SUCCESS,
  FETCH_LIST_STAFF_FAILURE,
  FETCH_LIST_STAFF_REQUEST,
  FETCH_LIST_STAFF_SUCCESS,
  FETCH_STAFF_FAILURE,
  FETCH_STAFF_REQUEST,
  FETCH_STAFF_SUCCESS,
  HISTORY_STAFF_FAILURE,
  HISTORY_STAFF_REQUEST,
  HISTORY_STAFF_SUCCESS,
  RESET_CURRENT_STAFF,
  UPDATE_STAFF_FAILURE,
  UPDATE_STAFF_REQUEST,
  UPDATE_STAFF_SUCCESS
} from './staffType';

const initialState = {

  addStaffs: { ...defaultStatus },
  deleteStaff: { ...defaultStatus },
  fetchListStaff: { ...defaultStatus },
  fetchStaff: { ...defaultStatus },
  updateStaff: { ...defaultStatus },
  historyStaff: { ...defaultStatus }
}

const staffReducer = (state = initialState, action) => {

  const { type, payload } = action || {};


  switch (type) {
    
    case FETCH_LIST_STAFF_REQUEST:
      return {
        ...state,
        fetchListStaff: {
          ...state.fetchListStaff,
          inProgress: true,
          error: null
        }
      }
    case FETCH_LIST_STAFF_SUCCESS:
      return {
        ...state,
        fetchListStaff: {
          ...state.fetchListStaff,
          inProgress: false,
          success: true,
          data: payload?.staff
        },
      }
    case FETCH_LIST_STAFF_FAILURE:
      return {
        ...state,
        fetchListStaff: {
          ...state.fetchListStaff,
          inProgress: false,
          error: true,
          errorMessage: payload.error
        }
      }
      case HISTORY_STAFF_REQUEST:
        return {
          ...state,
          historyStaff: {
            ...state.fetchListStaff,
            inProgress: true,
            error: null
          }
        }
      case HISTORY_STAFF_SUCCESS:
        return {
          ...state,
          historyStaff: {
            ...state.fetchListStaff,
            inProgress: false,
            success: true,
            data: payload?.staff?.data
          },
        }
      case HISTORY_STAFF_FAILURE:
        return {
          ...state,
          historyStaff: {
            ...state.fetchListStaff,
            inProgress: false,
            error: true,
            errorMessage: payload.error
          }
        }
    
    case FETCH_STAFF_REQUEST:
      return {
        ...state,
        fetchStaff: { ...state.fetchStaff, inProgress: true, error: null }
      }
 case FETCH_STAFF_SUCCESS:
  return {
    ...state,
    fetchStaff: {
      ...state.fetchStaff,
      inProgress: false,
      success: true,
      data: payload?.staff,
    },
  }
    case FETCH_STAFF_FAILURE:
      return {
        ...state,
        fetchStaff: {
          ...state.fetchStaff,
          inProgress: false,
          error: true,
          errorMessage: payload.error
        }
      }

   
         case ADD_STAFF_REQUEST:
           return {
             ...state,
             addStaffs: { 
               ...state.addStaffs, 
               inProgress: true, 
               success: false,
               error: false,
               errorMessage: null
             }
           };
         case ADD_STAFF_SUCCESS:
           return {
             ...state,
             addStaffs: {
               ...state.addStaffs,
               inProgress: false,
               success: true,
               error:false,
               data: payload?.staffs
             },
           };
           case ADD_STAFF_FAILURE:
            return {
              ...state,
              addStaffs: {
                ...state.addStaffs,
                inProgress: false,
                success: false,
                error: true,
                errorMessage: payload?.error || payload?.errorMessage || 'Something went wrong',
                data: [],
                errorFields: payload?.errorFields || null
              }
            };
          
    // Edit staff
    case UPDATE_STAFF_REQUEST:
      return {
        ...state,
        updateStaff: { ...state.updateStaff, inProgress: true, error: null }
      }
    case UPDATE_STAFF_SUCCESS: {
      return {
        ...state,
        updateStaff: {
            ...state.updateStaff,
            inProgress: false,
            success: true,
            error:false,
            data: payload?.staff
          },
      }
    }
    case UPDATE_STAFF_FAILURE:
      return {
        ...state,
        updateStaff: {
            ...state.updateStaff,
            inProgress: false,
            success: false,
            error: true,
            errorMessage: payload?.error || payload?.errorMessage || 'Something went wrong',
            data: [],
            errorFields: payload?.errorFields || null
          }
      }

    // Delete staff
    case DELETE_STAFF_REQUEST:
      return {
        ...state,
        deleteStaff: { ...state.deleteStaff, inProgress: true, error: null }
      }
    case DELETE_STAFF_SUCCESS:
      return {
        ...state,
        deleteStaff: {
          ...state.deleteStaff,
          inProgress: false,
          success: true
        },
        staff: {
          ...state.staff,
          data: state.staff.data.filter(
            staff => staff.id !== payload.staffId
          )
        },
        currentStaff:
          state.currentStaff.data?.id === payload.staffId
            ? { ...defaultStatus, data: null }
            : state.currentStaff
      }
    case DELETE_STAFF_FAILURE:
      return {
        ...state,
        deleteStaff: {
          ...state.deleteStaff,
          inProgress: false,
          error: true,
          errorMessage: payload.error
        }
      }

    // Reset current staff
    case RESET_CURRENT_STAFF:
      return { ...defaultStatus }

    default:
      return state
  }
}

export default staffReducer